import { tableCell } from './TableCell.css';
import type { TPostTableCellProps } from './TableCell.types';

export { tableCell as postTableCellClass } from './TableCell.css';

export const PostTableCell = (props: TPostTableCellProps) => {
  const { children } = props;

  return (
    <td className={tableCell} valign="top">
      {children}
    </td>
  );
};
